/* eslint-disable no-console */
import {Select} from 'antd';
import React from 'react';

import {filterSelectOptions} from '../Forms/Utils/commonFunctions';

const SearchBar: React.FC<{
  mapData: any[];
  markerRef: any[];
  setSelectedFacility: React.Dispatch<React.SetStateAction<string | undefined>>;
}> = ({mapData, markerRef, setSelectedFacility}) => {
  const handleSelect = (value: string) => {
    const index = mapData.findIndex((option) => option._id === value);
    markerRef[index].fire('click');
    setSelectedFacility(value);
  };

  return (
    <div className="searchBar">
      <Select
        showSearch
        allowClear
        placeholder="Search..."
        onSelect={handleSelect}
        style={{width: '200px'}}
        filterOption={filterSelectOptions}
        options={mapData.map((option) => ({
          value: option._id,
          label: option.name
        }))}
      />
    </div>
  );
};

export default SearchBar;
